import { CurrentUserEffects } from '®shared/current-user/current-user.effects';
import { TenantEffects } from '®shared/tenant/tenant.effects';

export const effects = [CurrentUserEffects, TenantEffects];
